import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 7a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3l0 -10","key":"svg-0"}],["path",{"d":"M7 10a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-1"}],["path",{"d":"M15 8l2 0","key":"svg-2"}],["path",{"d":"M15 12l2 0","key":"svg-3"}],["path",{"d":"M7 16l10 0","key":"svg-4"}]]

const IconId = createReactComponent('outline', 'id', 'Id', __iconNode);

export default IconId;